"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var hooks_1 = require("containers/Admin/CustomerManagement/CompanyActions/hooks");
var ScheduleReminders = function (_a) {
    var templateSelection = _a.templateSelection;
    var _b = __read((0, hooks_1.useScheduleReminders)(templateSelection), 3), isLoading = _b[0], uploadReminders = _b[1], error = _b[2];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("input", { type: "file", name: "Scheduled Reminder File Upload", id: "schedule-reminders", accept: ".csv", onChange: function (onChangeEvent) {
                    var _a;
                    var file = (_a = onChangeEvent.target.files) === null || _a === void 0 ? void 0 : _a[0];
                    if (!file)
                        return;
                    var reader = new FileReader();
                    reader.readAsText(file);
                    reader.onload = function () {
                        // eslint-disable-next-line no-alert
                        if (window.confirm('Proceed with upload list of users for scheduled reminders?')) {
                            uploadReminders(reader.result);
                        }
                    };
                }, style: { display: 'none' } }), (0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: "schedule-reminders" }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ isSending: isLoading }, { children: "Upload CSV" })), error && (0, jsx_runtime_1.jsx)("span", __assign({ style: { marginLeft: 8 } }, { children: "ERROR: ".concat(error.toString()) }))] }))] }));
};
exports.default = ScheduleReminders;
